<template>
  <div
    class="py-2 text-white section section--border-top bg-dark lg:py-4"
    id="quiz-results"
  >
    <div class="container">
      <div class="container__inner px-1.5">
        <div class="flex items-center pb-1 section-title lg:pb-2">
          <h2 class="text-base uppercase lg:text-lg">
            {{ quizStore.quiz.title }}
          </h2>
        </div>
        <div class="flex items-center section-title">
          <CircleIcon
            class="text-green fill-current mr-0.5 h-0.625 w-0.625 lg:h-1.25 lg:w-1.25"
          />

          <h3 class="text-sm uppercase lg:text-base">Les réponses</h3>
        </div>
        <!-- .section-title -->
        <div class="quiz-slider">
          <div class="flex flex-wrap justify-between">
            <div class="w-full lg:w-10/12">
              <div class="swiper">
                <swiper-container
                  id="swiper-quiz-results"
                  class="swiper-wrapper"
                  :auto-height="true"
                  :slides-per-view="1"
                  :navigation="{
                    nextEl: '#quiz-results .swiper-button-next',
                    prevEl: '#quiz-results .swiper-button-prev',
                  }"
                  :enable="swiperEnabled"
                >
                  <swiper-slide
                    class="quiz-result-item swiper-slide"
                    v-for="(question, idx) in answeredQuestions"
                  >
                    <div class="flex flex-wrap py-1">
                      <div class="pt-0.5 pr-1.5 leading-normal flex-shrink-0">
                        {{ idx + 1 }}/{{ answeredQuestions.length }}
                      </div>
                      <p class="flex-1 p-0 m-0 text-2xl leading-normal">
                        {{ question.title }}
                      </p>
                    </div>

                    <component
                      :is="quizResultsTypes[question.type]"
                      :question="question"
                      :answer="
                        quizStore.answers.find(
                          (answer) =>
                            parseInt(answer.question_id) == question.id
                        )
                      "
                    />

                    <!-- .flex -->
                  </swiper-slide>
                  <!-- . swiper-slide -->
                </swiper-container>
                <!-- .swiper-wrapper -->
              </div>
              <!-- .swiper -->
            </div>
            <div class="flex items-center w-full lg:w-2/12">
              <div
                class="relative flex flex-row items-center w-full quiz-slider__toolbar lg:flex-col"
              >
                <div
                  class="after:content-none swiper-button-prev border border-solid border-white rounded flex items-center justify-center h-3 w-3 lg:h-4.5 lg:w-4.5 m-1 rotate-90 text-white relative left-0"
                >
                  <CaretIcon class="w-1.5 h-1.5 stroke-current" />
                </div>
                <div
                  class="after:content-none swiper-button-next border border-solid border-white rounded flex items-center justify-center h-3 w-3 lg:h-4.5 lg:w-4.5 m-1 -rotate-90 text-white relative left-0"
                >
                  <CaretIcon class="w-1.5 h-1.5 stroke-current" />
                </div>
              </div>
              <!-- .quiz-slider__toolbar -->
            </div>
          </div>
          <!-- .flex -->
        </div>
        <!-- .quiz-slider -->
      </div>
      <!-- .container__inner -->
    </div>
    <!-- .container -->
  </div>
  <!-- .section -->
</template>
<script setup>
import { onMounted, ref } from "vue";
import { register as registerSwiper } from "swiper/element/bundle";
import { useSwiper } from "swiper/vue";
import { useQuizStore } from "@/stores/quiz";
import CircleIcon from "./icons/CircleIcon.vue";
import CaretIcon from "./icons/CaretIcon.vue";

import QuizResultsQCU from "./QuizResultsQCM.vue";
import QuizResultsQCM from "./QuizResultsQCM.vue";
import QuizResultsQPO from "./QuizResultsQPO.vue";
import QuizResultsQPA from "./QuizResultsQPA.vue";
import QuizResultsQRS from "./QuizResultsQRS.vue";
registerSwiper();
const swiper = useSwiper();

const quizResultsTypes = {
  QCU: QuizResultsQCU,
  QCM: QuizResultsQCM,
  QPO: QuizResultsQPO,
  QPA: QuizResultsQPA,
  QRS: QuizResultsQRS,
};

const quizStore = useQuizStore();
const questions = Object.values(quizStore.quiz.segments).flatMap(
  (segment) => segment.questions
);
const answeredQuestions = questions.filter((question) =>
  quizStore.answers.find(
    (answer) => parseInt(answer.question_id) == question.id
  )
);
const swiperEnabled = ref(false);
onMounted(() => {
  setTimeout(() => {
    swiperEnabled.value = true;
    // swiper.init();
  }, 250);
});
</script>
